import React from 'react';

export default function ThankYou() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#4A7A63] text-white text-center">
            <div>
                <h1 className="text-4xl font-bold mb-4">Thank You!</h1>
                <p className="text-lg">Your request has been received. We'll contact you soon.</p>
            </div>
        </div>
    );
}
